import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AppState } from 'src/app/app.state';
import { routeTo } from 'src/app/core/routing/routing.actions';
import { selectRecoverState } from '../recover/recover.selectors';

@Injectable({
	providedIn: 'root',
})
export class VerifyGuard {
	/**
	 * Verify guard constructor
	 * @param store The global store
	 */
	constructor(private store: Store<AppState>) {}

	canActivate(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		let credentials;

		this.store.select(selectRecoverState).subscribe((resp) => {
			credentials = resp;
		});

		// Regular login
		if (credentials.order_id && credentials.email) {
			return true;
		}
		// Auto login
		if (credentials.eToken && credentials.oToken) {
			return true;
		}
		// Order search
		if (credentials.email && credentials.phone) {
			return true;
		}

		this.store.dispatch(routeTo({ payload: ['recover'] }));
		return false;
	}
}
